import styled from 'styled-components'

export const ManagePickupTimesWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/Components/City/Page/ManagePickupTimes/ManagePickupTimesWrapper/index.js